import { JobInformation } from '@seek/hirer-job-information';
import { useTranslations } from '@vocab/react';
import { Box, Stack, Text, Loader } from 'braid-design-system';
import type React from 'react';

import { useQueryJob } from '../../../hooks/useQueryJob';
import translations from '../JobInformationDialog/.vocab';

import { mapJobDetails } from './mapJobDetails';

interface JobInformationContentProps {
  jobId: string;
}

export const JobInformationContent: React.FC<
  React.PropsWithChildren<JobInformationContentProps>
> = ({ jobId }) => {
  const { data, error, loading } = useQueryJob(jobId);
  const { t } = useTranslations(translations);
  const jobDetails = mapJobDetails(data?.job);

  if (error) {
    return (
      <Box paddingY="small">
        <Text tone="secondary">{t('ErrorMessage')}</Text>
      </Box>
    );
  }

  return (
    <Stack space="medium">
      <Box background="surface">
        {!loading && jobDetails ? (
          <JobInformation jobDetails={jobDetails} />
        ) : (
          <Box display="flex" justifyContent="center" padding="large">
            <Loader />
          </Box>
        )}
      </Box>
    </Stack>
  );
};
